import React from 'react';
import { config } from 'config';
import { useLocalstorage } from 'hooks';
import { useTranslation } from 'react-i18next';
import {
    AbsenceRate,
    AbsenceReports,
    AbsencesByLicense,
    ActiveAbsences
} from './components';
const { absenceReport } = config;

const ACTIVE = 'active';
const BY_LICENSE = 'absences_by_license';
const RATE = 'absence_rate';
const REPORTS = 'absence_reports';

const StatisticsAbsenteesm = () => {

    const { t } = useTranslation();

    const [selectedTab, setSelectedTab] = useLocalstorage('statistics-absenteeism-tab', {
        defaultValue: absenceReport ? REPORTS : BY_LICENSE
    });

    const tabController = {
        selectedTab,
        setSelectedTab,
        tabs: [{
            hidden: !absenceReport,
            label: t('Informes de ausencia'),
            value: REPORTS
        }, {
            hidden: !absenceReport,
            label: t('Ausencias activas'),
            value: ACTIVE
        }, {
            label: t('Ausencias por licencia'),
            value: BY_LICENSE
        }, {
            label: t('Tasa de ausentismo'),
            value: RATE
        }].filter(({ hidden }) => !hidden)
    };

    switch (selectedTab) {
    case (ACTIVE): return <ActiveAbsences tabController={ tabController } />;
    case (BY_LICENSE): return <AbsencesByLicense tabController={ tabController } />;
    case (REPORTS): return absenceReport ? <AbsenceReports tabController={ tabController } /> : null;
    case (RATE): return <AbsenceRate tabController={ tabController } />;
    default: return <AbsencesByLicense tabController={ tabController } />;
    }
};

export default StatisticsAbsenteesm;
